import type { FC, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps extends HTMLAttributes<HTMLElement> {
    as?: 'p' | 'span' | 'h2' | 'h3' | 'dt'
}

// Small monospaced label used above headings and for meta information.
export const Eyebrow: FC<EyebrowProps> = ({ as: Tag = 'p', className, ...props }): ReactNode => {
    return (
        <Tag
            className={cn('font-mono text-xs uppercase tracking-[0.16em] text-muted-foreground', className)}
            {...props}
        />
    )
}
